export interface ItemChecklist {
  chave: string;
  rotulo: string;
  pronta: boolean;
  icone?: string;
  ajuda?: string;
  aoClicar: () => void;
}

interface Props {
  /** Itens que travam o Publicar (só mostram quando falta algo). */
  pendentes: ItemChecklist[];
  /** Itens opcionais — convite, nunca cobrança. */
  melhorias: ItemChecklist[];
}

export default function ChecklistPublicar({ pendentes, melhorias }: Props) {
  const faltam = pendentes.filter((p) => !p.pronta).length;

  return (
    <div className="space-y-4">
      {faltam > 0 && (
        <section className="overflow-hidden rounded-lg border border-secondary-200 bg-white">
          <h4 className="border-b border-secondary-100 px-5 py-3 text-sm font-medium text-foreground-950">
            Para publicar, falta
          </h4>
          <ul>
            {pendentes.map((p, i) => (
              <li key={p.chave} className={i > 0 ? 'border-t border-secondary-100' : ''}>
                <button
                  type="button"
                  onClick={p.aoClicar}
                  className="flex w-full cursor-pointer items-center gap-3 px-5 py-2.5 text-left transition-colors hover:bg-background-50"
                >
                  <span
                    className={`flex h-5 w-5 shrink-0 items-center justify-center ${
                      p.pronta ? 'text-green-600' : 'text-amber-500'
                    }`}
                  >
                    <i className={p.pronta ? 'ri-check-line' : 'ri-alert-line'} />
                  </span>
                  <span
                    className={`text-sm ${p.pronta ? 'text-secondary-500' : 'text-foreground-900'}`}
                  >
                    {p.rotulo}
                  </span>
                  {!p.pronta && (
                    <span className="ml-auto flex items-center gap-1 whitespace-nowrap text-sm text-primary-600">
                      preencher
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-arrow-right-line" />
                      </span>
                    </span>
                  )}
                </button>
              </li>
            ))}
          </ul>
        </section>
      )}

      {melhorias.length > 0 && (
        <section className="overflow-hidden rounded-lg border border-secondary-200 bg-white">
          <h4 className="border-b border-secondary-100 px-5 py-3 text-sm font-medium text-foreground-950">
            Melhora muito
          </h4>
          <ul>
            {melhorias.map((m, i) => (
              <li key={m.chave} className={i > 0 ? 'border-t border-secondary-100' : ''}>
                <button
                  type="button"
                  onClick={m.aoClicar}
                  className="flex w-full cursor-pointer items-center gap-3 px-5 py-3 text-left transition-colors hover:bg-background-50"
                >
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center ${
                      m.pronta ? 'text-green-600' : 'text-secondary-400'
                    }`}
                  >
                    <i className={m.pronta ? 'ri-checkbox-circle-line' : (m.icone || 'ri-add-circle-line')} />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm font-medium text-foreground-900">
                      {m.rotulo}
                    </span>
                    {m.ajuda && (
                      <span className="block text-xs text-secondary-500">{m.ajuda}</span>
                    )}
                  </span>
                  {!m.pronta && (
                    <span className="whitespace-nowrap text-sm text-primary-600">adicionar →</span>
                  )}
                </button>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}